// Mirrors the backend's ConnectorSource.
export type ConnectorSource = "google-drive" | "onedrive";

export interface FileSource {
    source: ConnectorSource;
    url?: string;
}

// A File cannot carry extra fields, so its origin is kept beside it.
const origins = new WeakMap<File, FileSource>();

export const rememberSource = (file: File, origin: FileSource): File => {
    origins.set(file, origin);
    return file;
};

export const sourceOf = (file: File): FileSource | undefined =>
    origins.get(file);
